<template>
  <div
    class="print:height-max flex h-dvh flex-col items-center gap-4 overflow-hidden print:items-stretch print:overflow-visible!"
    :class="highlightBgClass"
  >
    <header class="w-full print:hidden">
      <NavbarLayout />
      <SidebarLayout class="z-10" />
    </header>
    <HeaderLayout />
    <main
      v-if="route.meta.fullHeight"
      class="flex grow flex-col"
      :class="route.meta.width ?? 'container print:mx-0 print:min-w-full'"
    >
      <RouterView />
    </main>
    <ScrollArea
      v-else
      as="main"
      :vertical="route.meta.verticalScroll ?? true"
      :horizontal="route.meta.horizontalScroll"
      class="relative grow"
      :class="route.meta.width ?? 'container print:mx-0 print:min-w-full'"
    >
      <div class="flex grow flex-col">
        <RouterView />
      </div>
    </ScrollArea>
    <footer class="w-full max-sm:px-3 print:hidden">
      <FooterLayout />
    </footer>
    <CompanionDialog v-model:open="showCompanionDialog" />
    <EdgeFabButton @click="showCompanionDialog = true" />
    <SelectSourceDialog v-if="route.meta.requiresSource" :open="!currentSource" />
  </div>
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';
import ScrollArea from '../components/ScrollArea.vue';
import FooterLayout from './FooterLayout.vue';
import HeaderLayout from './HeaderLayout.vue';
import NavbarLayout from './NavbarLayout.vue';
import SidebarLayout from './SidebarLayout.vue';
import { provideFormContext } from '../contexts/formContext';
import { ref } from 'vue';
import EdgeFabButton from '../components/EdgeFabButton.vue';
import CompanionDialog from '../components/dialog/CompanionDialog.vue';
import { useSource } from '../stores/sourceStore.ts';
import SelectSourceDialog from '../components/dialog/SelectSourceDialog.vue';
import { useHighlightBg } from '../stores/highlightBgStore.ts';

const route = useRoute();
const { currentSource } = useSource();
const showCompanionDialog = ref(false);

const { highlightBgClass } = useHighlightBg();

provideFormContext();
</script>
